import { SiteUtilities, LocationUtilities } from './utils';

const pricingFeatureComparison = function (isLocalPricing) {
  var jsonData;
  var selectedCountry;
  var country;
  var countryName;

  SiteUtilities.onModuleLoad('lib/odometer').then(Odometer => Odometer.init());

  const odoPoller = window.setInterval(function () {
    if (typeof window.Odometer !== 'undefined') {
      clearOdoPoller();
      window.Odometer.init();
    }
  }, 500);

  const clearOdoPoller = function () {
    window.clearInterval(odoPoller);
  };

  /*
   * A list of countires defined as EU.
  */
  const countryEU = [
    'Austria',
    'Belgium',
    'Cyprus',
    'Estonia',
    'Finland',
    'France',
    'Germany',
    'Greece',
    'Ireland',
    'Italy',
    'Latvia',
    'Luxembourg',
    'Malta',
    'Netherlands',
    'Portugal',
    'Slovakia',
    'Slovenia',
    'Spain',
    'Andorra',
    'Kosovo',
    'Montenegro',
    'Monaco',
    'San Marino',
    'The Vatican City'
  ];
  const southAmerica = [
    'Mexico',
    'Brazil',
    'Panama',
    'Costa Rica',
    'Argentina',
    'Chile',
    'Uruguay',
    'Paraguay',
    'Bolivia',
    'Peru',
    'Dominican Republic',
    'Colombia'
  ];
  const asiaPacific = [
    'Vietnam',
    'Philippines',
    'Indonesia',
    'Thailand'
  ];
  /*
   * jsonUrls are urls of json data for each product pricing.
  */
  var jsonUrls = {
    fworks: '/static-assets/js/pricing-fworks.json',
    fcaller: '/static-assets/js/pricing-fcaller.json',
    fsales: '/static-assets/js/pricing-fsales.json',
    fservice: '/static-assets/js/pricing-fservice.json',
    fdesk: '/static-assets/js/pricing-fdesk.json',
    fteam: '/static-assets/js/pricing-fteam.json',
    fchat: '/static-assets/js/pricing-fchat.json'
  };
  /*
   * Appending time to the json because json assets are usually cached in s3 and are not hashed.
  */
  var dateObject = new Date();
  var timeStamp = dateObject.getDay() + '' + dateObject.getMonth() + '' + dateObject.getYear();

  let $mainPricingCompareTable = $('#pricing-compare:not(.addon-pricing-header)');
  let $monthlyYearlyPricingAddonFeatureTables = $('.localized-pricing-plans-comparison-table.monthly-yearly-pricing');
  let $fixedPricingAddonFeatureTables = $('.localized-pricing-plans-comparison-table:not(.monthly-yearly-pricing)');
  /*
   * producKey is to get the product name from pricing-table
   * page. Product name is set in 'data-product' attribute
   * in pricing-table class element.
  */
  var productKey = jQuery('.table-headings').attr('data-product');
  jQuery.getJSON(jsonUrls[productKey] + `?t=${timeStamp}&v=2.6`, function (json) {
    jsonData = json;
    selectedCountry = selectCountry(jsonData);
    var pricingSymbol = jsonData[selectedCountry];
    if (jQuery('.addon-pricing-header').length > 0) {
      jQuery('.addon-pricing-header .pricing-currency-symbol').text('+' + ' ' + pricingSymbol['symbol']);
    }
    $mainPricingCompareTable.find('.pricing-currency-symbol').html(pricingSymbol['symbol']);
    if (jQuery('body').attr('data-product-name') === 'fservice' || 'fdesk') {
      priceAnnual();
    } else {
      priceMonthly();
    }
    // for lengthy currencies, we add an extra class to
    // adjust the styling to accommodate the extra characters
    if (pricingSymbol['symbol'].length > 1) {
      $mainPricingCompareTable.find('.pricing-currency-symbol').addClass('long-currency');
    }
    /*
    * Setting currency symbol if page head-banner
    * has local currency symbols.
    */

    // setting omnichanel agent prcing
    if (jQuery('.addon-pricing-header').length > 0) {
      var countrypricing = jsonData[selectedCountry];
      var pricing = [countrypricing['sprout_omni_agent'], countrypricing['blossom_omni_agent'], countrypricing['garden_omni_agent'], countrypricing['estate_omni_agent'], countrypricing['forest_omni_agent']];
      jQuery('.addon-pricing-header .price-value').each(function (ind, val) {
        jQuery(val).text(pricing[ind]);
      });
    }

    if ($fixedPricingAddonFeatureTables.length > 0) {
      handleAddonFeaturePricingTables($fixedPricingAddonFeatureTables, 'fixed');
    }

    if (jQuery('.banner-currency-symbol').length > 0) {
      jQuery('.banner-currency-symbol').html(pricingSymbol['symbol']);
      // for now its only for fservice
      if (productKey === 'fservice') {
        jQuery('.banner-currency-price').html(jsonData[selectedCountry]['blossom_annual']);
      }
    }
    /*
    * adding additional asset cost for fsercice pricing-compare page
    * if pricing.json has key 'additional_asset'
    */
    if (jsonData[selectedCountry]['additional_asset_cost']) {
      jQuery('.additional-asset-cost').html(jsonData[selectedCountry]['symbol'] + ' ' + jsonData[selectedCountry]['additional_asset_cost']);
    }
    /*
     * This if condition checks pricing_switch [input] is checked or
     * not by default. If checked its updated annual price based on
     * the country.
    */
    if (jQuery('input#pricing_switch').is(':checked')) {
      setClassForYearly();
      priceAnnual();
    } else {
      setClassForMonthly();
      priceMonthly();
    }
  });

  function selectCountry (data) {
    LocationUtilities.onLocationReady(function (geoLocation) {
      country = geoLocation.country.iso_code;
      countryName = geoLocation.country.names.en;
    });
    if (isLocalPricing === 'false') {
      return 'US';
    } else {
      if (jQuery.inArray(countryName, countryEU) !== -1) {
        country = 'EU';
      } else if (jQuery.inArray(countryName, southAmerica) !== -1) {
        country = 'SOUTH-AMERICA';
      } else if (jQuery.inArray(countryName, asiaPacific) !== -1) {
        country = 'APAC';
      }
      const localeCountryCode = SiteUtilities.getLocaleCountryCode();
      if (localeCountryCode) {
        country = localeCountryCode;
      }
      return (country in data) ? country : 'US';
    }
  }
  // function to change pricing values based on table and pricingValues
  // this function seperates the common functionality of changing the price for either dynamic pricing or fixed pricing
  function changePricingValues ($item, localizedPricing, type) {
    const selectCountryPricing = localizedPricing[selectedCountry];
    if (selectCountryPricing) {
      const $sproutPriceValue = $item.find('#sprout-price-value');
      const $blossomPriceValue = $item.find('#blossom-price-value');
      const $gardenPriceValue = $item.find('#garden-price-value');
      const $estatePriceValue = $item.find('#estate-price-value');
      const $forestPriceValue = $item.find('#forest-price-value');
      if ($sproutPriceValue.length > 0 && !isNaN(parseInt(selectCountryPricing['sprout_' + type]))) {
        $sproutPriceValue.text(parseInt(selectCountryPricing['sprout_' + type]));
      }
      $blossomPriceValue.text(parseInt(selectCountryPricing['blossom_' + type]));
      $gardenPriceValue.text(parseInt(selectCountryPricing['garden_' + type]));
      if ($estatePriceValue.length > 0) {
        $estatePriceValue.text(parseInt(selectCountryPricing['estate_' + type]));
      }
      if ($forestPriceValue.length > 0) {
        $forestPriceValue.text(parseInt(selectCountryPricing['forest_' + type]));
      }
    }
  }
  // function to handle addon feature Pricing table
  function handleAddonFeaturePricingTables ($tables, type) {
    $tables.each(function () {
      const $this = $(this);
      let localePricingData = $this.attr('data-pricing');
      if (localePricingData && JSON.parse(localePricingData)[selectedCountry]) {
        localePricingData = JSON.parse(localePricingData);
        $this.find('.pricing-currency-symbol').text(localePricingData[selectedCountry]['symbol']);
        changePricingValues($this, localePricingData, type);
        if (type === 'annual') {
          $this.find('.agents-billed-period').removeClass('monthly');
        } else if (type === 'monthly') {
          $this.find('.agents-billed-period').addClass('monthly');
        }
      }
    });
  }

  function priceMonthly () {
    changePricingValues($mainPricingCompareTable, jsonData, 'monthly');
    $mainPricingCompareTable.find('.agents-billed-period').addClass('monthly');
    if ($monthlyYearlyPricingAddonFeatureTables.length > 0) {
      handleAddonFeaturePricingTables($monthlyYearlyPricingAddonFeatureTables, 'monthly');
    }
  }

  function priceAnnual () {
    changePricingValues($mainPricingCompareTable, jsonData, 'annual');
    $mainPricingCompareTable.find('.agents-billed-period').removeClass('monthly');
    if ($monthlyYearlyPricingAddonFeatureTables.length > 0) {
      handleAddonFeaturePricingTables($monthlyYearlyPricingAddonFeatureTables, 'annual');
    }
  }

  function setClassForMonthly () {
    jQuery('.pricing-package').removeClass('active');
    jQuery('.pricing-monthly').addClass('active');
  }
  function setClassForYearly () {
    jQuery('.pricing-package').removeClass('active');
    jQuery('.pricing-yearly').addClass('active');
  }

  jQuery('.pricing-toggle-button').on('click', function () {
    if (jQuery('input#pricing_switch').is(':checked')) {
      setClassForYearly();
      priceAnnual();
    } else {
      setClassForMonthly();
      priceMonthly();
    }
  });

  var checkBox = jQuery('input#pricing_switch');
  jQuery('.pricing-monthly').on('click', function () {
    if (checkBox.attr('checked')) {
      setClassForMonthly();
      checkBox.prop('checked', false);
      priceMonthly();
    }
  });
  jQuery('.pricing-yearly').on('click', function () {
    setClassForYearly();
    if (!checkBox.attr(':checked')) {
      checkBox.prop('checked', true);
      priceAnnual();
    }
  });
  window.odometerOptions = {
    duration: 500
  };
};

export { pricingFeatureComparison };
